<template>
    <div>
        <div id="title-variables">
            <b>VARIABLES MONITOREADAS</b>
        </div>
        <a-tabs type="card">
            <a-tab-pane 
                key="1" 
                tab="Precipitación" 
                v-if="showRainfall"
            >
                <Rainfall 
                    :charts="stationData" 
                    :index="index"
                    :indicator-a3="indicatorA3"
                    :indicator-a25="indicatorA25"
                />
            </a-tab-pane>

            <a-tab-pane 
                key="2" 
                tab="Temperatura" 
                v-if="showTemperature"
            >
                <Temperature 
                    :charts="stationData" 
                    :index="index" 
                />
            </a-tab-pane>

            <a-tab-pane 
                key="3" 
                tab="Humedad" 
                v-if="showHumidity"
            >
                <Humidity 
                    :charts="stationData" 
                    :index="index" 
                />
            </a-tab-pane>

            <a-tab-pane 
                key="4" 
                tab="Velocidad" 
                v-if="showVelocity"
            >
                <Velocity 
                    :charts="stationData" 
                    :index="index" 
                />
            </a-tab-pane>

            <a-tab-pane 
                key="5" 
                tab="Dirección" 
                v-if="showDirection"
            >
                <Direction 
                    :charts="stationData" 
                    :index="index" 
                />
            </a-tab-pane>

            <a-tab-pane 
                key="6" 
                tab="Presión" 
                v-if="showPressure"
            >
                <Pressure 
                    :charts="stationData" 
                    :index="index" 
                />
            </a-tab-pane>

            <a-tab-pane 
                key="7" 
                tab="Radiación" 
                v-if="showRadiation"
            >
                <Radiation 
                    :charts="stationData" 
                    :index="index" 
                />
            </a-tab-pane>

            <a-tab-pane 
                key="8" 
                tab="Nivel" 
                v-if="showLevel"
            >
                <Level 
                    :tare="stationInf.tare"
                    :charts="stationData" 
                    :index="index"
                />
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>

    import Rainfall from '@/components/StationListMenu/Tabs/Variables/Rainfall.vue';
    import Temperature from '@/components/StationListMenu/Tabs/Variables/Temperature.vue';
    import Humidity from '@/components/StationListMenu/Tabs/Variables/Humidity.vue';
    import Velocity from '@/components/StationListMenu/Tabs/Variables/Velocity.vue';
    import Direction from '@/components/StationListMenu/Tabs/Variables/Direction.vue';
    import Pressure from '@/components/StationListMenu/Tabs/Variables/Pressure.vue';
    import Radiation from '@/components/StationListMenu/Tabs/Variables/Radiation.vue';
    import Level from '@/components/StationListMenu/Tabs/Variables/Level.vue';

    export default {
        name: "Variable",

        components:{
            Rainfall,
            Temperature,
            Humidity,
            Velocity,
            Direction,
            Pressure,
            Radiation,
            Level
        },

        props:{
            stationInf: [],
            stationData: [],
            index: Number,
            indicatorA3: [],
            indicatorA25: []
        },

        /*
        * En caso de que la estación no transmita datos de alguna de las variables
        * esta no se mostrará. (Cada variable computada es asociada a un v-if de la variable correspondiente)
        */
        computed:{
            showRainfall(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].precipitation != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            },

            showTemperature(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].temperature != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            },

            showHumidity(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].humidity != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            },

            showVelocity(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].windSpeed != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            },

            showDirection(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].windDirection != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            },

            showPressure(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].presure != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            },

            showRadiation(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].radiation != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            },

            showLevel(){
                let cantidad_datos = 0
                for(var i in this.stationData){
                    if(this.stationData[i].level != null){
                        cantidad_datos ++
                    }
                }
                if(cantidad_datos > 0){
                    return true;
                }else{
                    return false;
                }
            }
        }
    };
</script>

<style scoped>
    #title-variables {
        text-align: center;
        margin-bottom: 1em;
    }
</style>